import { render } from "./BasicSetupTab.vue?vue&type=template&id=17b2eee8&scoped=true"
import script from "./BasicSetupTab.vue?vue&type=script&lang=js"
export * from "./BasicSetupTab.vue?vue&type=script&lang=js"

import "./BasicSetupTab.vue?vue&type=style&index=0&id=17b2eee8&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b2eee8"]])

export default __exports__